export default "__VITE_ASSET__a070563b__"